import {useCustomEventHandler} from './hooks';

export {useIntervalManager} from './hooks';

export const globalShared = {
  useCustomEventHandler,
};
